/**
 * react-select and scrollable modals (FormModal) use ResizeObserver internally.
 * Browsers may report "ResizeObserver loop completed with undelivered notifications"
 * which CRA's dev overlay treats as a fatal runtime error even though it is benign.
 *
 * Deferring callbacks to the next animation frame breaks the synchronous resize loop.
 */
export function setupResizeObserverLoopFix() {
  if (typeof window === 'undefined' || !window.ResizeObserver) {
    return;
  }

  const OriginalResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      let animationFrameId = null;

      super((entries, observer) => {
        if (animationFrameId !== null) {
          cancelAnimationFrame(animationFrameId);
        }

        animationFrameId = requestAnimationFrame(() => {
          animationFrameId = null;
          callback(entries, observer);
        });
      });
    }
  };
}

export function suppressResizeObserverOverlayErrors() {
  if (typeof window === 'undefined') {
    return;
  }

  const isResizeObserverLoopError = (message) =>
    typeof message === 'string' && message.includes('ResizeObserver loop');

  window.addEventListener(
    'error',
    (event) => {
      if (isResizeObserverLoopError(event.message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );
}
